(function (Drupal, $) {
  Drupal.behaviors.downloadsHistory = {
    attach: function (context) {
      $(".downloads .downloads__form", context).each(function () {
        $(this)
          .find(".js-form-submit.button")
          .wrap("<div class='submit-wrapper'></div>");
        $(this)
          .children(".icon-wrapper")
          .appendTo($(this).find(".submit-wrapper"));
      });
    },
  };
})(Drupal, jQuery);
